/**
 * Returns the combination of the given strings with dashes.
 *
 * @param strings Strings to concatenate.
 */
export const cssJoin = (...strings) =>
  strings.map(str => (str ? str : '')).join('-');
export default cssJoin;
